module.exports = __webpack_public_path__ + "static/img/login_logo5.2f2574a5.png";